import { Button, Divider, Group, Stack } from '@mantine/core';
import classes from './EditUserFormBase.module.css';
import { useUpdatePatientMutation } from '@/lib/graphql';
import useWhoAmI from '@/hooks/useWhoAmI';
import { UpdatePatientInput } from '@/lib/graphql/types';
import { UseFormReturnType } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import Icon from '@/components/Icon';

interface EditUserFormBaseProps {
  form: UseFormReturnType<UpdatePatientInput>;
  children: React.ReactNode;
  onClose: () => void;
}

const EditUserFormBase = ({
  form,
  children,
  onClose,
}: EditUserFormBaseProps) => {
  const { user } = useWhoAmI();

  const [updatePatient, { loading }] = useUpdatePatientMutation({
    awaitRefetchQueries: true,
    refetchQueries: ['WhoAmI'],
    onCompleted: () => {
      form.reset();
      onClose();
      notifications.show({
        id: 'sucess-edit',
        color: 'green',
        message: 'Your changes have been saved!',
        icon: (
          <Icon
            name="feather/check"
            variant="filled"
            meaning="positive"
            size="sm"
          />
        ),
      });
    },
  });

  const handleSubmit = (input: UpdatePatientInput) => {
    updatePatient({
      variables: {
        updatePatientId: user?.id,
        input,
      },
    });
  };

  return (
    <Stack gap={24}>
      <Divider size="xl" className={classes.divider} />
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack gap={24}>
          {children}
          <Group justify="space-between">
            <Button
              variant="outline"
              className={classes.actionButton}
              onClick={onClose}>
              Cancel
            </Button>
            <Button
              className={classes.actionButton}
              type="submit"
              disabled={!form.isDirty() || !form.isValid()}
              loading={loading}>
              Update
            </Button>
          </Group>
        </Stack>
      </form>
    </Stack>
  );
};

export default EditUserFormBase;
